export default class ValueList<T> {

    constructor(public values?: T[], public defaultValue?: T, public currentValue?: T) {
    }

    public setCurrentIndex(index: number) {
        if (this.values) {
            this.currentValue = this.values[index];
        }
    }

    public clone(): ValueList<T> {
        return new ValueList<T>(this.values, this.defaultValue, this.currentValue);
    }

    public getMin(): T {
        return this.values[0];
    }

    public getMax(): T {
        return this.values[this.values.length - 1];
    }

    public hasData() {
        return this.currentValue !== undefined || this.defaultValue !== undefined;
    }

    public getClamped(value: T) {
        if (value !== undefined) {
            if (value < this.getMin()) {
                value = this.getMin();
            } else if (value > this.getMax()) {
                value = this.getMax();
            }
        }

        return value;
    }
}
